<template>
  <head>
    <meta charset="utf-8" />
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM | User Roles</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Manage system user roles and permissions" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">User Roles Management</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="/dashboard">Dashboards</a></li>
                    <li class="breadcrumb-item active">User Roles</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Filters Section -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input
                              v-model="searchTerm"
                              @input="searchRoles"
                              type="text"
                              class="form-control"
                              placeholder="Search by role name or code..."
                          >
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <select v-model="selectedOrgLevel" @change="filterRoles" class="form-select">
                        <option value="">All Organization Levels</option>
                        <option v-for="level in organizationLevels" :key="level.level_id" :value="level.level_id">
                          {{ level.level_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <select v-model="filterStatus" @change="filterRoles" class="form-select">
                        <option value="">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <button @click="refreshData" class="btn btn-primary w-100">
                        <i class="mdi mdi-refresh"></i> Refresh
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Roles table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="mb-0">System User Roles</h4>

                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading roles...</p>
                  </div>

                  <!-- Error State -->
                  <div v-else-if="error" class="alert alert-danger" role="alert">
                    <i class="mdi mdi-alert-circle-outline me-2"></i>
                    {{ errorMessage }}
                    <button @click="fetchRoles" class="btn btn-sm btn-danger float-end">Retry</button>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table text-uppercase border">
                      <thead class="table-light">
                      <tr>
                        <th scope="col" width="5%">SN</th>
                        <th scope="col" title="Role Name">Role Name</th>
                        <th scope="col" title="Role Code">Role Code</th>
                        <th scope="col" title="Organization Level">Org Level</th>
                        <th title="The number of users under this role">Users</th>
                        <th title="System role indicator">System Role</th>
                        <th title="The date this role was created">Date Created</th>
                        <th>Status</th>
                        <th scope="col" class="text-right">Actions</th>
                      </tr>
                      </thead>
                      <tbody class="border">
                      <tr v-if="filteredRoles.length === 0">
                        <td colspan="9" class="text-center py-4">
                          <p class="mb-0 text-muted">No roles found</p>
                        </td>
                      </tr>
                      <tr v-for="(role, index) in filteredRoles" :key="role.role_id">
                        <td>{{ (currentPage - 1) * limit + index + 1 }}.</td>
                        <td>
                          <div>
                            <h5 class="font-size-14 mb-0">{{ role.role_name }}</h5>
                            <p class="text-muted mb-0 font-size-12">{{ role.description }}</p>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-info">{{ role.role_code }}</span>
                        </td>
                        <td>{{ role.level_name }}</td>
                        <td>
                          <span class="badge bg-primary">{{ role.user_count || 0 }}</span>
                        </td>
                        <td>
                              <span v-if="role.is_system_role" class="badge bg-warning">
                                <i class="mdi mdi-lock"></i> System
                              </span>
                          <span v-else class="badge bg-secondary">Custom</span>
                        </td>
                        <td>{{ formatDate(role.created_at) }}</td>
                        <td class="fw-bold text-black">
                          <p class="mb-0 text-truncate">
                            <i :class="role.is_active ? 'mdi mdi-circle text-success' : 'mdi mdi-circle text-warning'" class="me-1"></i>
                            {{ role.is_active ? 'Active' : 'Inactive' }}
                          </p>
                        </td>
                        <td class="text-uppercase text-right">
                          <div class="d-flex justify-content-end">
                            <button
                                @click="showDetailsModal(role)"
                                class="btn btn-sm btn-info text-uppercase mx-1"
                                title="View Role Details"
                            >
                              Details
                            </button>
                            <button
                                v-if="!role.is_system_role && role.is_active"
                                @click="showDeactivateModal(role)"
                                class="btn btn-sm btn-danger text-uppercase d-flex align-items-center mx-1"
                                title="Deactivate Role"
                                :disabled="deactivating"
                            >
                              <div>Deactivate</div>
                            </button>
                            <button
                                v-else-if="!role.is_system_role && !role.is_active"
                                @click="activateRole(role)"
                                class="btn btn-sm btn-success text-uppercase mx-1"
                                title="Activate Role"
                                :disabled="activating"
                            >
                              Activate
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Pagination -->
                    <div v-if="totalRoles > limit" class="row mt-4">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ offset + 1 }} to {{ Math.min(offset + limit, totalRoles) }} of {{ totalRoles }} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination">
                            <li class="paginate_button page-item previous" :class="{ disabled: offset === 0 }">
                              <a @click="previousPage" href="#" class="page-link">Previous</a>
                            </li>
                            <li
                                v-for="page in displayedPages"
                                :key="page"
                                class="paginate_button page-item"
                                :class="{ active: page === currentPage }"
                            >
                              <a @click="goToPage(page)" href="#" class="page-link">{{ page }}</a>
                            </li>
                            <li class="paginate_button page-item next" :class="{ disabled: offset + limit >= totalRoles }">
                              <a @click="nextPage" href="#" class="page-link">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->

          <!-- Statistics Cards -->
          <div class="row mt-4">
            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">Total Roles</p>
                      <h4 class="mb-2">{{ statistics.totalRoles || 0 }}</h4>
                      <p class="text-muted mb-0">All system roles</p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-primary rounded-3">
                          <i class="mdi mdi-account-group font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">Active Roles</p>
                      <h4 class="mb-2">{{ statistics.activeRoles || 0 }}</h4>
                      <p class="text-muted mb-0">Currently active</p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-success rounded-3">
                          <i class="mdi mdi-check-circle font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">Total Users</p>
                      <h4 class="mb-2">{{ statistics.totalUsers || 0 }}</h4>
                      <p class="text-muted mb-0">Assigned to roles</p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-info rounded-3">
                          <i class="mdi mdi-account font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">System Roles</p>
                      <h4 class="mb-2">{{ statistics.systemRoles || 0 }}</h4>
                      <p class="text-muted mb-0">Protected roles</p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-warning rounded-3">
                          <i class="mdi mdi-lock font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Role Details Modal -->
      <div v-if="showDetailsModalFlag" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header border-bottom">
              <h4 class="modal-title text-uppercase">
                <i class="mdi mdi-account-details me-2"></i>
                Role Details
              </h4>
              <button type="button" class="btn-close" @click="closeDetailsModal"></button>
            </div>
            <div class="modal-body" v-if="selectedRoleDetails">
              <div class="row">
                <!-- Basic Information -->
                <div class="col-lg-6">
                  <div class="card border">
                    <div class="card-header bg-light">
                      <h5 class="card-title mb-0">
                        <i class="mdi mdi-information-outline me-2"></i>
                        Basic Information
                      </h5>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table table-borderless table-sm">
                          <tbody>
                          <tr>
                            <td class="fw-bold" width="40%">Role Name:</td>
                            <td>{{ selectedRoleDetails.role_name }}</td>
                          </tr>
                          <tr>
                            <td class="fw-bold">Role Code:</td>
                            <td>
                              <span class="badge bg-info">{{ selectedRoleDetails.role_code }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="fw-bold">Description:</td>
                            <td>{{ selectedRoleDetails.description || 'No description available' }}</td>
                          </tr>
                          <tr>
                            <td class="fw-bold">Organization Level:</td>
                            <td>
                              <span class="badge bg-primary">{{ selectedRoleDetails.level_name }}</span>
                              <small class="text-muted ms-1">(Rank: {{ selectedRoleDetails.level_rank }})</small>
                            </td>
                          </tr>
                          <tr>
                            <td class="fw-bold">Role Type:</td>
                            <td>
                                <span v-if="selectedRoleDetails.is_system_role == '1'" class="badge bg-warning">
                                  <i class="mdi mdi-lock me-1"></i>System Role
                                </span>
                              <span v-else class="badge bg-secondary">
                                  <i class="mdi mdi-account-edit me-1"></i>Custom Role
                                </span>
                            </td>
                          </tr>
                          <tr>
                            <td class="fw-bold">Status:</td>
                            <td>
                                <span v-if="selectedRoleDetails.is_active" class="badge bg-success">
                                  <i class="mdi mdi-check-circle me-1"></i>Active
                                </span>
                              <span v-else class="badge bg-warning">
                                  <i class="mdi mdi-pause-circle me-1"></i>Inactive
                                </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Statistics -->
                <div class="col-lg-6">
                  <div class="card border">
                    <div class="card-header bg-light">
                      <h5 class="card-title mb-0">
                        <i class="mdi mdi-chart-bar me-2"></i>
                        Role Statistics
                      </h5>
                    </div>
                    <div class="card-body">
                      <div class="row text-center">
                        <div class="col-6 mb-3">
                          <div class="p-3 border rounded">
                            <h3 class="text-primary mb-1">{{ selectedRoleDetails.user_count || 0 }}</h3>
                            <p class="text-muted mb-0 small">Assigned Users</p>
                          </div>
                        </div>
                        <div class="col-6 mb-3">
                          <div class="p-3 border rounded">
                            <h3 class="text-info mb-1">{{ selectedRoleDetails.level_rank || 0 }}</h3>
                            <p class="text-muted mb-0 small">Hierarchy Level</p>
                          </div>
                        </div>
                      </div>

                      <!-- Additional Information -->
                      <div class="mt-4">
                        <h6 class="mb-3">Role Capabilities</h6>
                        <div class="d-flex flex-wrap gap-2">
                          <span v-if="selectedRoleDetails.is_system_role == '1'" class="badge bg-warning">
                            <i class="mdi mdi-shield-check me-1"></i>System Protected
                          </span>
                          <span v-if="selectedRoleDetails.user_count > 0" class="badge bg-success">
                            <i class="mdi mdi-account-multiple me-1"></i>Has Users
                          </span>
                          <span v-else class="badge bg-secondary">
                            <i class="mdi mdi-account-off me-1"></i>No Users Assigned
                          </span>
                          <span v-if="isHighLevelRole(selectedRoleDetails)" class="badge bg-info">
                            <i class="mdi mdi-crown me-1"></i>High Authority
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Role Permissions/Actions -->
              <div class="row mt-3">
                <div class="col-12">
                  <div class="card border">
                    <div class="card-header bg-light">
                      <h5 class="card-title mb-0">
                        <i class="mdi mdi-key-variant me-2"></i>
                        Role Actions & Notes
                      </h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <h6 class="text-muted mb-2">Available Actions:</h6>
                          <ul class="list-unstyled">
                            <li v-if="!selectedRoleDetails.is_system_role">
                              <i class="mdi mdi-pencil text-primary me-2"></i>
                              Can be modified
                            </li>
                            <li v-if="!selectedRoleDetails.is_system_role">
                              <i class="mdi mdi-delete text-danger me-2"></i>
                              Can be deactivated
                            </li>
                            <li>
                              <i class="mdi mdi-account-plus text-success me-2"></i>
                              Can assign users
                            </li>
                            <li>
                              <i class="mdi mdi-eye text-info me-2"></i>
                              View permissions
                            </li>
                          </ul>
                        </div>
                        <div class="col-md-6">
                          <h6 class="text-muted mb-2">Role Information:</h6>
                          <div class="text-muted small">
                            <p v-if="selectedRoleDetails.is_system_role == '1'" class="mb-2">
                              <i class="mdi mdi-information me-1"></i>
                              This is a system role and cannot be deleted or modified.
                            </p>
                            <p v-if="selectedRoleDetails.user_count > 0" class="mb-2">
                              <i class="mdi mdi-account-group me-1"></i>
                              {{ selectedRoleDetails.user_count }} user(s) currently assigned to this role.
                            </p>
                            <p class="mb-0">
                              <i class="mdi mdi-hierarchy me-1"></i>
                              Operates at {{ selectedRoleDetails.level_name }} level in the organizational hierarchy.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Role Timeline/History -->
              <div class="row mt-3">
                <div class="col-12">
                  <div class="card border">
                    <div class="card-header bg-light">
                      <h5 class="card-title mb-0">
                        <i class="mdi mdi-timeline me-2"></i>
                        Role Timeline
                      </h5>
                    </div>
                    <div class="card-body">
                      <div class="timeline">
                        <div class="timeline-item">
                          <div class="timeline-marker bg-primary"></div>
                          <div class="timeline-content">
                            <h6 class="mb-1">Role Created</h6>
                            <p class="text-muted mb-0 small">
                              Created on {{ formatDate(selectedRoleDetails.created_at) || 'Unknown date' }}
                            </p>
                          </div>
                        </div>
                        <div v-if="selectedRoleDetails.user_count > 0" class="timeline-item">
                          <div class="timeline-marker bg-success"></div>
                          <div class="timeline-content">
                            <h6 class="mb-1">Users Assigned</h6>
                            <p class="text-muted mb-0 small">
                              {{ selectedRoleDetails.user_count }} user(s) currently assigned
                            </p>
                          </div>
                        </div>
                        <div class="timeline-item">
                          <div class="timeline-marker" :class="selectedRoleDetails.is_active ? 'bg-success' : 'bg-warning'"></div>
                          <div class="timeline-content">
                            <h6 class="mb-1">Current Status</h6>
                            <p class="text-muted mb-0 small">
                              Role is currently {{ selectedRoleDetails.is_active ? 'active' : 'inactive' }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    v-if="!selectedRoleDetails.is_system_role"
                    class="btn btn-primary waves-effect waves-light"
                    @click="editRole(selectedRoleDetails)"
                >
                  <i class="mdi mdi-pencil me-1"></i>
                  Edit Role
                </button>
                <button
                    v-if="!selectedRoleDetails.is_system_role && selectedRoleDetails.is_active"
                    class="btn btn-warning waves-effect waves-light"
                    @click="showDeactivateModal(selectedRoleDetails)"
                >
                  <i class="mdi mdi-pause me-1"></i>
                  Deactivate
                </button>
                <button
                    v-else-if="!selectedRoleDetails.is_system_role && !selectedRoleDetails.is_active"
                    class="btn btn-success waves-effect waves-light"
                    @click="activateRole(selectedRoleDetails)"
                >
                  <i class="mdi mdi-play me-1"></i>
                  Activate
                </button>
                <button
                    type="button"
                    class="btn btn-secondary waves-effect"
                    @click="closeDetailsModal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Deactivation Modal -->
      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Deactivate User Role</h4>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body" v-if="selectedRole">
              <p>Are you sure you want to deactivate the role <strong class="text-primary">{{ selectedRole.role_name }}</strong>?</p>

              <div v-if="selectedRole.user_count > 0" class="alert alert-warning" role="alert">
                <i class="mdi mdi-alert-outline me-2"></i>
                This role has <strong>{{ selectedRole.user_count }}</strong> active user(s) assigned to it.
                Deactivating this role will affect these users.
              </div>

              <div class="row">
                <div class="col-12 mb-3">
                  <label for="deactivation-reason" class="form-label">Reason for Deactivation <span class="text-danger">*</span></label>
                  <textarea
                      v-model="deactivationReason"
                      id="deactivation-reason"
                      placeholder="Provide reason for deactivation"
                      class="form-control"
                      rows="3"
                      required
                  ></textarea>
                </div>
              </div>

              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    @click="confirmDeactivation"
                    :disabled="deactivating || !deactivationReason"
                    class="btn btn-danger waves-effect waves-light"
                >
                  <span v-if="deactivating" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ deactivating ? 'Processing...' : 'Confirm Deactivation' }}
                </button>
                <button
                    type="button"
                    class="btn btn-secondary waves-effect"
                    @click="closeModal"
                    :disabled="deactivating"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";

export default {
  name: "UsersRoles",
  components: { NavigationBar },
  data() {
    return {
      // Loading states
      loading: false,
      error: false,
      errorMessage: '',
      deactivating: false,
      activating: false,

      // Data
      roles: [],
      filteredRoles: [],
      organizationLevels: [],

      // Filters
      searchTerm: '',
      selectedOrgLevel: '',
      filterStatus: '',

      // Pagination
      limit: 10,
      offset: 0,
      totalRoles: 0,
      currentPage: 1,

      // Modal
      showModal: false,
      selectedRole: null,
      deactivationReason: '',

      // Details Modal
      showDetailsModalFlag: false,
      selectedRoleDetails: null,

      // Alert
      alert: {
        show: false,
        type: 'success',
        message: ''
      },

      // Statistics
      statistics: {
        totalRoles: 0,
        activeRoles: 0,
        totalUsers: 0,
        systemRoles: 0
      }
    };
  },

  mounted() {
    this.initializeComponent();
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalRoles / this.limit);
    },

    displayedPages() {
      const pages = [];
      const startPage = Math.max(1, this.currentPage - 2);
      const endPage = Math.min(this.totalPages, startPage + 4);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    }
  },

  methods: {
    // Initialize component
    async initializeComponent() {
      await Promise.all([
        this.fetchRoles(),
        this.fetchOrganizationLevels(),
        this.fetchStatistics()
      ]);
    },

    // Show details modal
    showDetailsModal(role) {
      this.selectedRoleDetails = { ...role };
      this.showDetailsModalFlag = true;
    },

    // Close details modal
    closeDetailsModal() {
      this.showDetailsModalFlag = false;
      this.selectedRoleDetails = null;
    },

    // Edit role
    editRole(role) {
      // Close details modal and redirect to edit page or show edit modal
      this.closeDetailsModal();
      // Redirect to edit page
      window.location.href = `/user-role-edit/${role.role_id}`;
    },

    // Check if role is high level
    isHighLevelRole(role) {
      return role.level_rank && parseInt(role.level_rank) <= 2; // National and Regional levels
    },

    // Fetch roles
    async fetchRoles() {
      this.loading = true;
      this.error = false;

      const data = {
        function: "getRoles",
        limit: this.limit,
        offset: this.offset
      };

      if (this.searchTerm) {
        data.searchTerm = this.searchTerm;
      }

      if (this.selectedOrgLevel) {
        data.organizationLevelId = this.selectedOrgLevel;
      }

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.roles = response.data.data.roles || [];
          this.totalRoles = this.roles.length; // Since getRoles doesn't have pagination
          this.applyLocalFilters();
        } else {
          this.error = true;
          this.errorMessage = response.data.message || 'Failed to load roles';
        }
      } catch (error) {
        this.error = true;
        this.errorMessage = error.message || 'An error occurred while loading roles';
      } finally {
        this.loading = false;
      }
    },

    // Fetch organization levels
    async fetchOrganizationLevels() {
      const data = {
        function: "getOrganizationLevels"
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.organizationLevels = response.data.data || [];
        }
      } catch (error) {
        console.error('Error fetching organization levels:', error);
        // Set default levels if API fails
        this.organizationLevels = [
          { level_id: 1, level_name: 'Ministry of Health' },
          { level_id: 2, level_name: 'Regional' },
          { level_id: 3, level_name: 'Zonal' },
          { level_id: 4, level_name: 'Woreda' },
          { level_id: 5, level_name: 'Facility' }
        ];
      }
    },

    // Fetch statistics
    async fetchStatistics() {
      // Calculate statistics from loaded roles
      if (this.roles.length > 0) {
        this.statistics.totalRoles = this.roles.length;
        this.statistics.activeRoles = this.roles.filter(r => r.is_active).length;
        this.statistics.systemRoles = this.roles.filter(r => r.is_system_role).length;
        this.statistics.totalUsers = this.roles.reduce((sum, role) => sum + (role.user_count || 0), 0);
      }
    },

    // Apply local filters
    applyLocalFilters() {
      let filtered = [...this.roles];

      // Apply status filter
      if (this.filterStatus) {
        filtered = filtered.filter(role => {
          if (this.filterStatus === 'active') return role.is_active;
          if (this.filterStatus === 'inactive') return !role.is_active;
          return true;
        });
      }

      // Apply pagination locally
      const start = this.offset;
      const end = start + this.limit;
      this.filteredRoles = filtered.slice(start, end);
      this.totalRoles = filtered.length;
    },

    // Search roles
    searchRoles() {
      this.offset = 0;
      this.currentPage = 1;
      this.fetchRoles();
    },

    // Filter roles
    filterRoles() {
      this.offset = 0;
      this.currentPage = 1;
      this.applyLocalFilters();
    },

    // Refresh data
    refreshData() {
      this.searchTerm = '';
      this.selectedOrgLevel = '';
      this.filterStatus = '';
      this.offset = 0;
      this.currentPage = 1;
      this.fetchRoles();
    },

    // Show deactivate modal
    showDeactivateModal(role) {
      this.closeDetailsModal(); // Close details modal if open
      this.selectedRole = role;
      this.deactivationReason = '';
      this.showModal = true;
      this.alert.show = false;
    },

    // Close modal
    closeModal() {
      this.showModal = false;
      this.selectedRole = null;
      this.deactivationReason = '';
      this.alert.show = false;
    },

    // Confirm deactivation
    async confirmDeactivation() {
      if (!this.selectedRole || !this.deactivationReason) return;

      this.deactivating = true;
      this.alert.show = false;

      const data = {
        function: "updateRole",
        roleId: this.selectedRole.role_id,
        status: 'inactive',
        reason: this.deactivationReason
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.alert.show = true;
          this.alert.type = 'success';
          this.alert.message = 'Role deactivated successfully!';

          // Update local data
          const index = this.roles.findIndex(r => r.role_id === this.selectedRole.role_id);
          if (index !== -1) {
            this.roles[index].is_active = false;
          }

          // Refresh and close modal
          setTimeout(() => {
            this.closeModal();
            this.applyLocalFilters();
            this.fetchStatistics();
          }, 2000);
        } else {
          this.alert.show = true;
          this.alert.type = 'danger';
          this.alert.message = response.data.message || 'Failed to deactivate role';
        }
      } catch (error) {
        this.alert.show = true;
        this.alert.type = 'danger';
        this.alert.message = error.message || 'An error occurred while deactivating the role';
      } finally {
        this.deactivating = false;
      }
    },

    // Activate role
    async activateRole(role) {
      if (!confirm(`Are you sure you want to activate the role "${role.role_name}"?`)) {
        return;
      }

      this.activating = true;

      const data = {
        function: "updateRole",
        roleId: role.role_id,
        status: 'active'
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          // Update local data
          const index = this.roles.findIndex(r => r.role_id === role.role_id);
          if (index !== -1) {
            this.roles[index].is_active = true;
          }

          this.applyLocalFilters();
          this.fetchStatistics();
          this.closeDetailsModal(); // Close details modal if open

          // Show success message
          alert('Role activated successfully!');
        } else {
          alert(response.data.message || 'Failed to activate role');
        }
      } catch (error) {
        alert(error.message || 'An error occurred while activating the role');
      } finally {
        this.activating = false;
      }
    },

    // Format date
    formatDate(dateString) {
      if (!dateString) return 'N/A';

      const date = new Date(dateString);
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      };

      return date.toLocaleDateString('en-US', options);
    },

    // Pagination methods
    previousPage() {
      if (this.offset > 0) {
        this.offset = Math.max(0, this.offset - this.limit);
        this.currentPage--;
        this.applyLocalFilters();
      }
    },

    nextPage() {
      if (this.offset + this.limit < this.totalRoles) {
        this.offset += this.limit;
        this.currentPage++;
        this.applyLocalFilters();
      }
    },

    goToPage(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.limit;
      this.applyLocalFilters();
    }
  }
};
</script>

<style scoped>
.search-box {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #74788d;
}

.search-box input {
  padding-left: 35px;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
  opacity: 0.6;
}

.page-item.active .page-link {
  background-color: #556ee6;
  border-color: #556ee6;
}

.modal.show {
  display: block !important;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Timeline styles */
.timeline {
  position: relative;
  padding-left: 30px;
}

.timeline-item {
  position: relative;
  margin-bottom: 20px;
}

.timeline-item:not(:last-child)::before {
  content: '';
  position: absolute;
  left: -24px;
  top: 20px;
  width: 2px;
  height: calc(100% + 10px);
  background-color: #e9ecef;
}

.timeline-marker {
  position: absolute;
  left: -30px;
  top: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #e9ecef;
}

.timeline-content {
  background: #f8f9fa;
  padding: 10px 15px;
  border-radius: 8px;
  border-left: 3px solid #dee2e6;
}

.modal-xl {
  max-width: 1200px;
}

/* Card hover effects */
.card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: box-shadow 0.3s ease;
}

/* Badge styling */
.badge {
  font-size: 0.875em;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modal-xl {
    max-width: 95%;
    margin: 10px auto;
  }

  .timeline {
    padding-left: 20px;
  }

  .timeline-marker {
    left: -20px;
  }

  .timeline-item:not(:last-child)::before {
    left: -14px;
  }
}
</style>